import { render } from "./TestimonialPage.vue?vue&type=template&id=9282188e&scoped=true"
import script from "./TestimonialPage.vue?vue&type=script&lang=js"
export * from "./TestimonialPage.vue?vue&type=script&lang=js"

import "./TestimonialPage.vue?vue&type=style&index=0&id=9282188e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9282188e"]])

export default __exports__